<script lang="ts">
	import avatarAndSistrall from '$lib/images/avatar-and-sistrall.svg';
	import { locale } from '$lib/translations';
</script>

<div class="p-2 font-sans font-bold md:p-4 lg:p-8">
	<a href={`/${$locale}`} class="inline *:max-h-16 *:w-auto">
		<img src={avatarAndSistrall} alt="sistrall.it" width="50%" height="50%" />
	</a>
</div>
